module.exports = __webpack_public_path__ + "img/bientot-button.498bf6c5.png";